import { gql } from "@apollo/client";

export const GET_CONFORMIDADES = gql`
query GetConformidades($filter: ConformidadSearchFilterInput!) {
  conformidades(filter: $filter) {
    success
    error
    valorEsperado {
      idEvaluacion
      delegacion
      paciente
      cod_Cliente
      cliente
      fDesde
      fHasta
      idConformidad
      idMetodoEnvio
      fechaGestion
      fechaProcesamiento
      puedeEnviarMail
    }
  }
}`;
